import { useContext } from "react";
import GridDataContext from "core/providers/grid-data-context";
import { Trans } from "react-i18next";
import context from "core/tv-guide.context";
import { observer } from "mobx-react-lite";
import { AppContext } from "core/providers/tv-guide.context";
import { DimensionBlock } from "core/providers/grid.store";

type DateButtonsProps = {
  setScrollX: (x: number) => void;
  horizontalScrollIndexes: number[];
  dateIndex: number;
}

const DateButtons = observer((props: DateButtonsProps) => {
  const gridData = useContext(GridDataContext);
  const appContext = useContext(AppContext);

  const dictionary = context.dictionary;
  const store = appContext.store;

  const dates = store.dates;

  if (!dates.length || !gridData.dimensionBlock) {
    return null;
  }

  const dimensionBlock = gridData.dimensionBlock as DimensionBlock;

  const click = (dateIndex: number) => {
    gridData.updateDateIndex(dateIndex);

    props.setScrollX(dimensionBlock.gridWidth * dateIndex);
  }

  return (
    <div className="date-button-holder">
      {dates.map((dateItem: Date, dateIndex: number) => {
        const isActive = dateIndex === props.dateIndex;

        return (
          <button
            type="button"
            className={isActive ? "highlight" : ""}
            onClick={() => click(dateIndex)}
            key={dateItem.toDateString()}>

            <p className="date-text-day">
              {dateIndex === 0
                ? (dictionary.today) :
                <Trans
                  i18nKey="dateTitle.day"
                  defaults="{{ days, datetime }}"
                  values={{
                    days: dateItem,
                    formatParams: {
                      days: { weekday: "short" },
                    },
                  }}
                />}
            </p>

            <p className="date-text-body">
              <Trans
                i18nKey="dateTitle.day"
                defaults="{{ days, datetime }}"
                values={{
                  days: dateItem,
                  formatParams: {
                    days: { day: "2-digit", month: "short" },
                  },
                }}
              />
            </p>
          </button>
        );
      })}
    </div>
  );
});

export default DateButtons;
